/* eslint-disable no-undef */
export default {
    set selectedFarmId(value) {
        localStorage.setItem("filterFarmId", value);
    },
    get selectedFarmId() {
        const value = localStorage.getItem("filterFarmId");
        return value === 'undefined' ? undefined : value;
    },
    set selectedMonth(value) {
        localStorage.setItem("filterMonth", value);
    },
    get selectedMonth() {
        let month = localStorage.getItem("filterMonth");
        if (month === 'undefined' || month === undefined || month == null || month == '') {
            return null;
        }

        return parseInt(month);
    },
    set selectedYear(value) {
        localStorage.setItem("filterYear", value);
    },
    get selectedYear() {
        let year = localStorage.getItem("filterYear");
        if (year === 'undefined' || year === undefined || year == null || year == '') {
            return null;
        }

        return parseInt(year);
    },
    set reportingTab(value) {
        localStorage.setItem("filterTab", value);
    },
    get reportingTab() {
        const value = localStorage.getItem("filterTab");
        return value === 'undefined' ? undefined : value;
    },
    set signInName(value) {
        localStorage.setItem("signInName", value);
    },
    get signInName() {
        let signInName = localStorage.getItem("signInName");
        return signInName === 'undefined' || signInName === undefined || signInName == null || signInName == '' ? null : signInName;
    },
    set signInMobileNumber(value) {
        localStorage.setItem("signInMobileNumber", value);
    },
    get signInMobileNumber() {
        let mobileNumber = localStorage.getItem("signInMobileNumber");
        return mobileNumber === 'undefined' || mobileNumber === undefined || mobileNumber == null || mobileNumber == '' ? null : mobileNumber;
    },
    set signInContractor(value) {
        localStorage.setItem("signInContractor", JSON.stringify(value));
    },
    get signInContractor() {
        let signInContractor = localStorage.getItem("signInContractor");
        return signInContractor === 'undefined' || signInContractor === undefined || signInContractor == null || signInContractor == '' ? null : JSON.parse(signInContractor);
    },
}